import { render } from "./ShiftCalendar.vue?vue&type=template&id=1990ca40"
import script from "./ShiftCalendar.vue?vue&type=script&lang=js"
export * from "./ShiftCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__